// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"eu-z","tooltipWrapper":"fu-z","icon":"gu-z","tooltip":"hu-z","content":"iu-z"};